import { CaseDocumentAdmin } from "pwapi";

import {
  ADMIN_DELETE_CASE_DOCUMENT_SUCCESS,
  ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS,
  ADMIN_UPLOAD_CASE_DOCUMENT_SUCCESS,
} from "../../actions/adminConstants";
import {
  ADMIN_CASE_DOCUMENTS_LIST_FAILURE,
  ADMIN_CASE_DOCUMENTS_LIST_REQUEST,
  ADMIN_CASE_DOCUMENTS_LIST_SUCCESS,
} from "../../actions/adminConstants";

export interface AdminDocumentsState {
  results: CaseDocumentAdmin[];
  count: number;
  previous: number | null;
  next: number | null;
  loading: boolean;
}

export const initialState: AdminDocumentsState = {
  results: [],
  count: 0,
  previous: null,
  next: null,
  loading: false,
};

const reducer = (
  state: AdminDocumentsState = initialState,
  action: any
): AdminDocumentsState => {
  switch (action.type) {
    case ADMIN_CASE_DOCUMENTS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADMIN_CASE_DOCUMENTS_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case ADMIN_CASE_DOCUMENTS_LIST_SUCCESS:
      return {
        ...action.payload,
        loading: false,
      };
    case ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS:
      return {
        ...state,
        results: state.results.map((adminDocument) => {
          return adminDocument.id === action.payload.id
            ? {
                ...adminDocument,
                ...action.payload,
              }
            : adminDocument;
        }),
      };
    case ADMIN_UPLOAD_CASE_DOCUMENT_SUCCESS:
      return {
        ...state,
        results: [...state.results, action.payload],
      };
    case ADMIN_DELETE_CASE_DOCUMENT_SUCCESS:
      return (
        state && {
          ...state,
          results: state.results?.filter((doc) => doc.id !== action.payload.id),
        }
      );
    default:
      return state;
  }
};

export default reducer;
